'use es6';

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const RegexSpan = styled.span.withConfig({
  displayName: "DisplayValueRegex__RegexSpan",
  componentId: "sc-6ey6gn-0"
})(["word-break:break-all;"]);
export default function DisplayValueRegex(props) {
  const {
    value
  } = props;
  return value ? /*#__PURE__*/_jsx(RegexSpan, {
    "data-selenium-test": "RegexSpan",
    children: value
  }) : null;
}
DisplayValueRegex.propTypes = {
  value: PropTypes.string.isRequired
};